import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { ThemeProvider } from 'styled-components'
import { Grid, Cell } from 'styled-css-grid'
import { Header } from '../components/Header/Header'
import { Wrapper } from '../components/Wrapper/Wrapper'
import { SocialContainer } from '../components/Social/SocialContainer'

import '../styles/global-styles'
import styl from './layout.styl'

const Layout = ({ children, data }) => (
  <main className="main">
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    {/* <Header siteTitle={ data.site.siteMetadata.title } /> */}

    {/* <Wrapper>{ children() }</Wrapper> */}
    <div className="wrapper">
      <div className="hero-container hero-container__homepage center">
        <header>
          <span className="hero-container__subhead">What's a Ross?</span>
          <div className="hero-container__contact">
            <a href="mailto:ross.lemenille@gmail.com" className="meta-link">
              Contact
            </a>
          </div>
        </header>

        <div className="hero-container__content left">
          <h1>Ross Lemenille</h1>
          {/* <h2>Developer Creative</h2> */}
          <p>
            I'm a <span className="highlight">creative software engineer</span>{' '}
            with experience using a wide breadth of technologies to build
            engaging user-centered digital products and solutions for global
            audiences. I thrive in high-caliber and collaborative environments
            where I can dream big.
          </p>
          <p>
            Recently, a <span className="highlight">Software Engineer II</span>{' '}
            at{' '}
            <a
              href="https://www.bottlerocketstudios.com/"
              className="meta-link"
              target="_blank"
            >
              {' '}
              Bottle Rocket Studios
            </a>{' '}
            where, I built elegant, modern, and intuitive front-end
            applications.
          </p>
          <p>
            Formerly, the{' '}
            <span className="highlight">Senior Web Developer</span> on the
            interactive digital team at <span>Discovery, Inc.'s</span> in-house{' '}
            <a
              href="https://agency.discovery.com/"
              className="meta-link"
              target="_blank"
            >
              creative agency
            </a>
            .
          </p>
          <div className="hero-container__subhead">Where's Ross?</div>
          <SocialContainer className="hero" />
        </div>
      </div>

      <section className="recent-work">
        <div className="recent-work__grid grid2x2">
          <div className="section-title">
            <h2>Highlighted Work</h2>
          </div>

          <div className="recent-work__item vr">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroDiscoveryVR.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              {/* <div className="recent-work__description"> */}
              <h2>Discovery VR</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                Discovery VR was initially an incubator project that was
                conceptualized, designed, and launched by the digital agency
                team at Discovery. We produced 360 video content for
                multi-platform experiences across web, mobile (iOS/Android),
                Oculus Rift and Gear VR.
              </p>
              <p>
                I lead the technical development, architecture, and API modeling
                for the mobile apps and accompanying website. I was also
                responsible for creating the custom video streaming profiles
                across all platforms.
              </p>
              {/* </div> */}
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery VR</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React Native, React (SSR), ES6, Webpack, MongoDB, Express,
                  Heroku, CloudFront, Imgix, Contentful
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://wwwprod.discoveryvr.com"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>Discovery VR</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item mm">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroMotorMayhem.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              <h2>Motor Mayhem</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                As part of Discovery's Motor Monday's programming producers
                wanted to compliment the television show Street Outlaws by
                giving the super-fans a way to show off their custom cars and
                compete in a 6-week bracket contest.
                {/* This gave users a feel of being part of larger community and connection to the show. */}
              </p>
              <p>
                I lead the development of a real-time user-generated site that
                allowed fans to upload pictures, videos, and details about their
                rides and profile creation. Users could vote, comment, edit and
                share their profiles on social networks.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  Firebase, React (SSR), Redux, ES6, Webpack, Express, Heroku,
                  AWS (S3, Cognito, CloudFront), Imgix
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://mm-prod.motormayhem.discovery.com/"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>Motor Mayhem</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item lotb">
            <div className="recent-work__image">
              <Img sizes={{ ...data.heroLotb.sizes, aspectRatio: 16 / 9 }} />
            </div>

            <div className="recent-work__content">
              <h2>Lords of the Boards</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                Discovery Channel's move back to scripted series looked at the
                history of one of America's most iconic brands: Harley Davidson.
                This is a digital extension of the show's telling of how in the
                early days of motorcycle racing was a blood sport with little or
                no regard for safety. The racers literally raced in what was
                called, "The Murderdrome."
              </p>
              <p>
                Along with building out the front-end, I was responsible for
                making the large hero cinemagraphs come to life using canvas.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery Channel</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React, ES2015+, Webpack, S3, Canvas
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://dsc.agency.discovery.com/harley/lotb/staging/the-murderdrome/"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>Lords of the Boards</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item mb">
            <div className="recent-work__image">
              <Img sizes={{ ...data.heroMB360.sizes, aspectRatio: 16 / 9 }} />
            </div>

            <div className="recent-work__content">
              <h2>MythBusters 360</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                MythBusters is an iconic show for Discovery and for their final
                season, we wanted to give users a look back at their famous
                Blueprint Room and showcase the most memorable myths. In this
                360 panoramic experience, users can interact with props in the
                room, watch highlights from Jamie and Adam, view 360 images, and
                deep-link to individual locations.
              </p>
              <p>
                Using KRPano, I created the interactions the user could take
                around the room and focused on a lean mobile experience.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery Channel</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React, ES2015+, Gulp, KRPano, S3, CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="https://www.mythbusters360.com"
                  className="button link"
                  target="_blank"
                >
                  Visit <span>MythBusters 360</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item dc">
            <div className="recent-work__image">
              <Img sizes={{ ...data.heroDC360.sizes, aspectRatio: 16 / 9 }} />
            </div>

            <div className="recent-work__content">
              <h2>Deadliest Catch 360</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                After a hugely popular behind-the-scenes tour from from a
                previous season of Deadliest Catch, the digital producers wanted
                to create something much more immersive - a 360 panoramic view
                of the 3 most popular ships from the show: Northwestern, Time
                Bandit, and Cornelia Marie.
              </p>
              <p>
                By using KRPano, users are able to navigate throughout the 75+
                locations across all 3 ships and see their favorite places and
                some never seen places up close and personal. I used the Web
                Audio API extensively for distinct engine sounds and commentary
                from the crew. I also later enabled a Web VR experience that
                could be used with Google Cardboard or the Samsung Gear VR
                browser.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery Channel</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  jQuery, GSAP, Swig, Web Audio API, KRPano, Gulp, S3,
                  CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="https://www.deadliestcatch360.com"
                  className="button link"
                  target="_blank"
                >
                  Visit <span>Deadliest Catch 360</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item sky">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroSkyscraper.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              <h2>Skyscraper Live</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                This media-rich and internationalized site promoted Discovery
                Channel's "tent-pole" project, "Skyscraper Live," a live
                globally televised event for Nik Wallenda's attempt to walk
                across two skyscrapers in downtown Chicago. The site supported
                19 regions and 13 languages which showcased Nik's training,
                behind the scenes photos, and a 3D interactive walk. The site
                supported the digital broadcast and gave users the chance to
                follow along with a second screen experience tracking Nik's
                progress across the wire.
              </p>
              <p>
                I supported the building out of the front-end application and
                layout, including internationlizing and localizing content,
                geo-location routing, and building custom video player logic.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery Channel</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  jQuery, Swig, i18n, Geo-targeting, Sass, Grunt, S3,
                  CloudFront, Brightcove
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://skyscraper.staging.agency.discovery.com.s3-website-us-east-1.amazonaws.com/"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>Skyscraper Live</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item pc">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroProjectCAT.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              <h2>Project C.A.T.</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                Project C.A.T. is an effort by Discovery, Inc. and their partner
                the World Wildlife Fund to support a global effort to double the
                number of tigers in the wild by 2022. This collaboration aims to
                ensure a healthy habitat for future generations of tigers by
                helping conserve nearly two million acres of protected land in
                India and Bhutan.
              </p>
              <p>
                The site was originally designed to be a small static site to
                bring attention to these endagered tigers and their ecosystem,
                but it now supports rich media content, internationalization and
                localized content, and donations.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React, Redux, GraphQL, ES2015+, Stylus, Webpack, i18n,
                  Geo-targeting, S3, CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="https://projectcat.discovery.com"
                  className="button link"
                  target="_blank"
                >
                  Visit <span>Project C.A.T.</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item mh">
            <div className="recent-work__image">
              <Img sizes={{ ...data.heroManhunt.sizes, aspectRatio: 16 / 9 }} />
            </div>

            <div className="recent-work__content">
              <h2>Manhunt: Unabomber</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                Discovery Channel's digital producers for the scripted series,
                "Manhunt: Unabomber" wanted to give their users a deeper look at
                the events that were covered in the 3-part miniseries. This
                timeline based site includes clips from the series, 360 panos of
                his cabin, historial photographs, and covers the events of Ted
                Kaczynski's life and through his conviction.
              </p>
              <p>
                I was responsible for building out the layout and main
                navigation, including the scroll-aware timeline.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Discovery</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React, ES2015+, Stylus, Webpack, S3, CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="https://manhunt.discovery.com/unabomber/"
                  className="button link"
                  target="_blank"
                >
                  Visit <span>Manhunt</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item ww">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroWhaleWars.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              <h2>Whale Wars: Blood and Water</h2>
              <span className="recent-work__label">Overview</span>
              <p>
                This interactive storytelling experience dives into the history
                of whale hunting and the strife of Paul Watson and the Sea
                Shepherd Conservation Society against Japanese whaling in the
                Southern Ocean Whale Santuary of Antartica.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">Animal Planet</span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  jQuery, Swig, Grunt, Web Audio API, HTML5 Video, S3,
                  CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://apl.agency.discovery.com/whale-wars/demo/index.html"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>Blood and Water</span>
                </a>
              </div>
            </div>
          </div>

          <div className="recent-work__item euro">
            <div className="recent-work__image">
              <Img
                sizes={{ ...data.heroEurosport.sizes, aspectRatio: 16 / 9 }}
              />
            </div>

            <div className="recent-work__content">
              <h2>Eurosport | US Open</h2>
              <div className="recent-work__meta">
                <span className="recent-work__label">Overview</span>
              </div>
              <p>
                To support new ad sales avenues in our international regions, I
                worked on a quick prototype site for Eurosport which could live
                as a standalone experience in a CMS. The site told the story of
                the life of a ball girl at the US Open and a look at the
                requirements and training involved.
              </p>
            </div>

            <div className="recent-work__details">
              <div className="recent-work__meta">
                <div className="recent-work__col">
                  <span className="recent-work__label">Made At</span>
                  <span className="recent-work__info">
                    Discovery, Inc. <br />
                    Agency
                  </span>
                </div>
                <div className="recent-work__col">
                  <span className="recent-work__label">Client</span>
                  <span className="recent-work__info">
                    Discovery / Eurosport Ad Sales
                  </span>
                </div>
              </div>

              <div className="recent-work__meta">
                <span className="recent-work__label">Stack</span>
                <span className="recent-work__info">
                  React, ES2015+, Stylus, Webpack, S3, CloudFront
                </span>
              </div>

              <div className="recent-work__meta">
                <a
                  href="http://prototypes.agency.discovery.com/us-open/"
                  className="button link"
                  target="_blank"
                  rel="nofollow"
                >
                  Visit <span>US Open</span>
                </a>
              </div>
            </div>
          </div>

          {/* <div className="recent-work__item">
              <div className="recent-work__image">
                <Img
                    sizes={ data.headerImage.sizes }
                  />
                <h3>SCI2.tv</h3>
              </div>

              <div className="recent-work__content">
                <h2>SCI2.tv</h2>
                <p></p>
              </div>
            </div>

            <div className="recent-work__item">
              <div className="recent-work__image">
                <Img
                    sizes={ data.headerImage.sizes }
                  />
                <h3>Animal Planet L!VE</h3>
              </div>

              <div className="recent-work__content">
                <h2>Animal Planet L!VE</h2>
                <p></p>
              </div>
            </div> */}
        </div>
      </section>
    </div>

    <footer>
      <div className="footer__container">
        <div className="footer__title">
          <h2>Ross Lemenille</h2>
          <span className="footer__tagline">Software Engineer</span>
        </div>
        <SocialContainer className="footer" textual={true} />
      </div>
    </footer>

    {/* <Footer></Footer> */}
  </main>
)

Layout.propTypes = {
  children: PropTypes.func,
}

// export const query = graphql`
//   query SiteTitleQuery {
//     site {
//       siteMetadata {
//         title
//       }
//     }
//   }
// `

export const pageQuery = graphql`
  query headerImageQueryAndSiteTitleQuery {
    heroDiscoveryVR: imageSharp(id: { regex: "/discovery-vr/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroMotorMayhem: imageSharp(id: { regex: "/motor-mayhem/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroLotb: imageSharp(id: { regex: "/lotb/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroDC360: imageSharp(id: { regex: "/dc360/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroMB360: imageSharp(id: { regex: "/mb360/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroSkyscraper: imageSharp(id: { regex: "/skyscraper/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroProjectCAT: imageSharp(id: { regex: "/project-cat/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroManhunt: imageSharp(id: { regex: "/manhunt/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroWhaleWars: imageSharp(id: { regex: "/whale-wars/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    heroEurosport: imageSharp(id: { regex: "/eurosport/" }) {
      sizes(maxWidth: 1280) {
        ...GatsbyImageSharpSizes
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js